import { useContext } from "react";

import { UniversalBenchmarksModalContext } from "../universal-benchmarks-modal-provider";

export const useUniversalBenchmarksModalContext = () => {
  const context = useContext(UniversalBenchmarksModalContext);

  if (!context) {
    throw new Error(
      "useUniversalBenchmarksModalContext can only be used inside UniversalBenchmarksModalContext",
    );
  }

  return context;
};
